// AUTO-GENERATED by scripts/gen-version.js — do not edit by hand.
// Regenerated on every "npm start" / "npm run build".
export const APP_VERSION = "1.0.40";
export const BUILD_TIME = "2026-11-04T06:42:25.067Z";
export const BUILD_ID = "1.0.40+2026-11-04T06:42:25.067Z";
